import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchContactBalancePayment } from '../query-api'

export const useFetchContactBalancePayment = (contactBalancePaymentId?: string) => {
  const { data, isLoading } = useQuery(
    [QueryKeys.ContactBalancePayment, contactBalancePaymentId],
    () => fetchContactBalancePayment(contactBalancePaymentId as string),
    { enabled: !!contactBalancePaymentId },
  )

  return { contactBalancePayment: data?.contactBalancePayment, isLoading }
}
